import './formikRadioButtonGroupComponent.scss'
import React, {useCallback} from 'react';
import {FieldProps} from "formik";
import RadioButtonGroupComponent from "../radio-button-group/radioButtonGroupComponent";
import _ from "lodash";

interface FormikRadioButtonGroupComponentProps {
    size?: "medium" | "small" | undefined;
    color?: "primary" | "secondary" | "default"|"info" | undefined;
    options: any[];
    isValueBoolean?: boolean; // ***** this must be TRUE when value is a boolean type value *****
    direction?: "row" | "column";
    titleKey?: string;
    valueKey?: string;
    onUpdate?: Function;
    id?: any;
    labelPlacement?: 'end' | 'start' | 'top' | 'bottom' | undefined;
    formikField: FieldProps;
    disabled?: boolean;
}

const FormikRadioButtonGroupComponent = (props: FormikRadioButtonGroupComponentProps) => {
        const {options, onUpdate, id} = props;

        let {color, size, direction, labelPlacement, titleKey, valueKey, isValueBoolean, formikField,disabled} = props;

        if (!color) color = "info";
        if (!direction) direction = "column";
        if (!size) size = "medium";
        if (!titleKey) titleKey = "title";
        if (!valueKey) valueKey = "code";
        const {field, form} = formikField;
        const {name, value} = field;
        const {touched, errors, setFieldValue} = form;
        const hasError = _.get(touched, name) && Boolean((_.get(errors, name)));

        const onOptionSelection = useCallback((newValue: any) => {
            let selectedValue: any = newValue;
            if (isValueBoolean) {
                selectedValue = newValue === true;
            }
            setFieldValue(name, selectedValue)
            if (onUpdate) {
                onUpdate(selectedValue);
            }
        }, [isValueBoolean, name, onUpdate, setFieldValue])

        return (
            <div>
                <RadioButtonGroupComponent
                    name={name}
                    direction={direction}
                    labelPlacement={labelPlacement}
                    hasError={hasError}
                    size={size}
                    value={value}
                    id={id}
                    color={color}
                    titleKey={titleKey}
                    valueKey={valueKey}
                    isValueBoolean={isValueBoolean}
                    onUpdate={(value: any) => onOptionSelection(value)}
                    errorMessage={hasError && (_.get(errors, name))}
                    disabled={disabled}
                    options={options}
                />
            </div>
        )
    }

;

export default FormikRadioButtonGroupComponent;
